/**
 * True inside the Tauri shell: the main window runs the live app from the server (ADR 0014), the quick
 * capture window the bundled client on tauri://localhost (cross-origin to the API).
 */
export const isTauri = typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window

/** Origin of api/auth. Empty = same origin (web app behind Caddy / Vite proxy). */
export const API_BASE: string =
  (import.meta.env.VITE_API_BASE as string | undefined) ?? (isTauri ? 'https://secondbrain.voluro.de' : '')

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`
}
